import React from "react";
import { reduxForm } from "redux-form";
import AccountFields from "../AccountFields";
import ProfileFields from "../ProfileFields";
import FieldValidationProvider from "../../Helpers/FieldValidator/FieldValidationProvider";

const LandlordAccountForm = ( props ) => {
    const { handleSubmit, validity, ...formProps } = props;
    return (
        <FieldValidationProvider validity={validity || {}}>
            <form className="Content-form" onSubmit={handleSubmit}>
                <ProfileFields landlord {...formProps}/>
                <AccountFields landlord {...formProps}/>
            </form>
        </FieldValidationProvider>
    );
}

export default reduxForm({
    form: "landlordAccount"
})( LandlordAccountForm );